import Api from '@/api/index'
import SessionHelper from '@/helpers/SessionHelper'

const state = {
  token: SessionHelper.token,
  role: SessionHelper.role,
  fullName: SessionHelper.fullName,
}

const getters = {
  isLoggedIn: state => {
    if (state.token === null && state.role === null) {
      return false
    }
    return true
  },
  sessionUser: state => ({
    TOKEN: state.token,
    ROLE: state.role,
    FULL_NAME: state.fullName,
  }),
}

const actions = {
  async login({ commit }, creds) {
    const user = await Api.CurrentSession.login(creds.email, creds.upass)
    if (user !== null) {
      commit('logged', user.data)
      commit('updateLocalStorage', user.data)
      return user
    }
    return null
  },
  logout({ commit }) {
    commit('clearSession')
    commit('clearLocalStorage')
    return true
  },
}

const mutations = {
  logged(state, user) {
    state.token = user.token
    state.role = user.role
    state.fullName = user.fullName
  },

  updateLocalStorage(state, user) {
    SessionHelper.update(user)
  },

  clearSession(state) {
    state.token = null
    state.role = null
    state.fullName = null
  },

  clearLocalStorage() {
    SessionHelper.clear()
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
